import React from "react";
import { Input, Select } from "../../../design-system";
import { levelLabel } from "../helpers";

export function DocumentsFilterBar({
  search,
  onSearchChange,
  levels,
  types,
  levelFilter,
  onLevelFilterChange,
  typeFilter,
  onTypeFilterChange,
  isManager,
  statusFilter,
  onStatusFilterChange,
  count,
}) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "12px 16px",
        borderBottom: "1px solid var(--kr-border-subtle)",
        flexWrap: "wrap",
      }}
    >
      <Input
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Buscar por título, código o archivo…"
        icon="Search"
        style={{ flex: 1, minWidth: 240, maxWidth: 360 }}
      />
      <Select
        value={levelFilter}
        onChange={(e) => onLevelFilterChange(e.target.value)}
        style={{ minWidth: 160 }}
      >
        <option value="all">Todos los niveles</option>
        {(levels || []).map((l) => (
          <option key={l.id} value={l.id}>
            {levelLabel(l)}
          </option>
        ))}
      </Select>
      <Select
        value={typeFilter}
        onChange={(e) => onTypeFilterChange(e.target.value)}
        style={{ minWidth: 160 }}
      >
        <option value="all">Todos los tipos</option>
        {(types || []).map((t) => (
          <option key={t.id} value={t.id}>
            {t.name}
          </option>
        ))}
      </Select>
      {isManager && (
        <Select
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value)}
          style={{ minWidth: 140 }}
        >
          <option value="all">Cualquier estado</option>
          <option value="draft">Borrador</option>
          <option value="published">Publicado</option>
          <option value="archived">Archivado</option>
        </Select>
      )}
      <div style={{ flex: 1 }} />
      <span
        style={{
          fontSize: 11,
          color: "var(--kr-fg-muted)",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          fontWeight: 600,
        }}
      >
        {count} documento{count === 1 ? "" : "s"}
      </span>
    </div>
  );
}
